import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import CardImage from "../../atoms/CardImage";
import Organism1 from "./Organism1";

import "./fullScreenFeatured.m.css";

const FullScreenFeatured = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { story } = collection.items[0];

  if (!story) {
    return null;
  }

  return (
    <div styleName="outer-wrapper">
      <ComponentContainer styleName="wrapper" collection={collection} isTitle={false}>
        <CardImage
          story={story}
          defaultWidth={760}
          aspectRatio={global.isMobile ? [3, 4] : [16, 9]}
          imageType={global.isMobile ? "image3x4" : "image16x9"}
          widths={[400, 900, 1248]}
          showStoryTypeIcon={false}
          showAlternateImage={false}
        />
        <Organism1 collection={collection} />
      </ComponentContainer>
    </div>
  );
};

FullScreenFeatured.propTypes = {
  collection: object.isRequired,
};

FullScreenFeatured.storyLimit = 1;

export default FullScreenFeatured;
